import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_INTERVENTIONTYPES } from "../../../utils/constants";
import interventionTypeService from "../../../services/ticketService/interventionTypeService";
import { InterventionTypeInterface } from "../../../models/TicketModule/InterventionType";

const useInterventionTypes = (page: number, pageSize: number) =>
  useQuery<InterventionTypeInterface[], Error>({
    queryKey: [
      CACHE_KEY_INTERVENTIONTYPES,
      page > 0 ? page : null,
      pageSize > 0 ? pageSize : null,
    ],
    queryFn: () => interventionTypeService.GetAll(page, pageSize),
  });

export default useInterventionTypes;
